var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AcRemoteWidget lxn-w100 lxn-h100 lxn-pos-rel",class:_vm.disabledClass},[_c('AcRemoteControllerSlim',{attrs:{"nodeUUID":_vm.nodeUUID,"outputIndex":_vm.outputIndex,"sendCommand":_vm.sendCommand,"showDummy":_vm.showDummy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }